import { BaseNavComponent, LayerNavComponent } from './baseClasses';
import { navigationLayers,wardLayer } from './layers';
import { getStateFeatures, getDistrictFeatures, getMunicipalityFeatures } from '../geojsonAPI';
import { fitToNepalBounds } from '../map';

export class Country extends BaseNavComponent
{
    constructor({ innerComponent })
    {
        super({ innerComponent });
    }

    async select(code, {reselect=false}={})
    {
        if (code===-1) return;
        if (!reselect && this.currentCode===code) return;
        
        // code can be used to select all district in country or municipality but
        // for now its not that useful
        this.currentCode = code;
        this.beforeSelect(code);

        // we can't clear from state to municipality. If we do that, we won't have any feature 
        // to execute click event. In short the invisible state layer always stays.
        this.innerComponent.innerComponent.clearFeatures({recursive: true});
        this.innerComponent.currentCode = 0;
        fitToNepalBounds();

        await this.afterSelect(code);
    }

    isSelected()
    {
        return this.currentCode!==-1;
    }
}

export class State extends LayerNavComponent
{
    constructor({innerComponent})
    {
        super({
            layer: navigationLayers.state,
            codeField: 'SCode',
            labelField: 'Province',
            innerComponent,
        });
        this.pluralName = "States";
        // adding state to the layer right away
        this.getAllFeaturesFromCache().then( features => this.addFeatures(features) );
    }

    getParentCode()
    {
        return 0; // because for national code, 0 => select all state 
    }

    async getAllFeaturesFromCache()
    {
        return await getStateFeatures();
    }
}

export class District extends LayerNavComponent
{
    constructor({innerComponent})
    {
        super({
            layer: navigationLayers.district,
            codeField: 'DCode',
            labelField: 'District',
            innerComponent,
        });
        this.pluralName = "Districts";
    }

    async getAllFeaturesFromCache()
    {
        return await getDistrictFeatures();
    }
}

export class Municipality extends LayerNavComponent
{
    constructor({innerComponent})
    {
        super({
            layer: navigationLayers.municipality,
            codeField: 'SDDMM',
            labelField: 'GaPa_NaPa',
            innerComponent,
        });
        this.pluralName = "Municipalities";
    }

    async select(code, {reselect=false}={})
    {
        const isSelection = await super.select(code, {reselect});
        if (isSelection)
        {
            const { wardLayer } = this.innerComponent;
            wardLayer.setVisible(true);
            const params = wardLayer.getSource().getParams();
            params.CQL_FILTER = `sddmm=${code}`;
            wardLayer.getSource().updateParams(params);
        }
    }

    async getAllFeaturesFromCache()
    {
        return await getMunicipalityFeatures();
    }
}

export class SoloMunicipality extends LayerNavComponent
{
    constructor()
    {
        super({
            layer: navigationLayers.soloMunicipality,
            codeField: 'SDDMM',
            labelField: 'GaPa_NaPa',
        });
        this.wardLayer = wardLayer;
    }

    addTo(map, {recursive=false})
    {
        map.addLayer(this.layer);
        map.addLayer(this.wardLayer);
        if (this.innerComponent && recursive) this.innerComponent.addTo(map, {recursive: true});
    }
    
    clearFeatures({recursive=false})
    {
        super.clearFeatures({recursive});
        this.wardLayer.setVisible(false);
    }

    async getAllFeaturesFromCache()
    {
        return await getMunicipalityFeatures();
    }
}